import React from "react";

// Animated red/black shopping-cart mascot. state: idle | listening | thinking | speaking | success | error
export function ShopNowAIMascot({ state = "idle", size = 44 }) {
  const mouth = {
    idle: "M46 74 Q60 82 74 74",
    listening: "M46 74 Q60 82 74 74",
    thinking: "M54 76 Q60 73 66 76",
    speaking: "M48 73 Q60 88 72 73",
    success: "M44 72 Q60 92 76 72",
    error: "M46 80 Q60 70 74 80",
  }[state] || "M46 74 Q60 82 74 74";

  return (
    <span className={`sn-mascot sn-mascot-${state}`} style={{ width: size, height: size, display: "inline-block" }} data-testid="shopnow-ai-mascot" aria-label="Shop Now AI">
      {state === "listening" && <span className="sn-mascot-ring" />}
      <svg viewBox="0 0 120 120" width={size} height={size} className="sn-mascot-svg">
        {/* handle */}
        <path d="M8 26 h12 l7 20" fill="none" stroke="#111" strokeWidth="6" strokeLinecap="round" strokeLinejoin="round" />
        {/* basket */}
        <path d="M27 40 H104 L94 86 H41 Z" fill="#E11B22" stroke="#111" strokeWidth="6" strokeLinejoin="round" />
        {/* basket grid accents */}
        <path d="M45 40 L49 86 M63 40 L64 86 M81 40 L79 86 M31 56 H101 M35 72 H97" stroke="#111" strokeWidth="3" opacity="0.28" fill="none" />
        {/* wheels */}
        <circle cx="50" cy="102" r="8" fill="#111" />
        <circle cx="86" cy="102" r="8" fill="#111" />
        {/* face */}
        <g className="sn-mascot-eyes">
          <circle cx="54" cy="60" r="9" fill="#fff" stroke="#111" strokeWidth="2.5" />
          <circle cx="78" cy="60" r="9" fill="#fff" stroke="#111" strokeWidth="2.5" />
          <circle className="sn-pupil" cx="54" cy="61" r="4" fill="#111" />
          <circle className="sn-pupil" cx="78" cy="61" r="4" fill="#111" />
        </g>
        <path className="sn-mascot-mouth" d={mouth} fill="none" stroke="#111" strokeWidth="4" strokeLinecap="round" />
        {state === "success" && <path d="M96 30 l3 6 6 3 -6 3 -3 6 -3 -6 -6 -3 6 -3 z" fill="#F4B740" />}
      </svg>
    </span>
  );
}
